import { BodyText, TitleText } from "@motain/web-shared-hub/ui/elements";
import { useParams } from "react-router";
import { useRedirectUrl } from "@/shared/hooks/useRedirectUrl";

export const OFClubPurchaseContainer = () => {
  const params = useParams();
  const redirectUrl = useRedirectUrl();
  const skuId = params.skuId || "";

  return (
    <div>
      <TitleText>This is where you place business logic</TitleText>
      <BodyText>
        Ideally, all business logic should only be placed in containers
      </BodyText>
      <BodyText>Rendered output should be ONLY UI dumb components</BodyText>
      <br />
      <br />
      <br />
      <BodyText>SKU: {skuId}</BodyText>
      <br />
      <a href={redirectUrl} target="_blank">
        Redirect url link
      </a>
    </div>
  );
};
